import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { LocalStorageService } from '@recruitee/common';
import { SubscriptionService } from '@recruitee/company-logic';
import { IconButtonComponent, IconComponent, ButtonComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-survey-banner',
  templateUrl: './survey-banner.component.html',
  styleUrls: ['./survey-banner.component.less'],
  imports: [IconButtonComponent, IconComponent, ButtonComponent],
})
export class SurveyBannerComponent implements OnInit {
  @Input() public componentStorageKey: string;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public buttonText: string;
  @Input() public buttonTextSuffix: string;
  @Input() public link: string;

  public visible: boolean | undefined = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    private subscriptionService: SubscriptionService,
  ) {}

  public ngOnInit(): void {
    this.visible = this.getBannerVisibility();
  }

  public markAsHidden() {
    this.visible = false;
    this.saveBannerVisibility();
    this.cdRef.detectChanges();
  }

  private saveBannerVisibility(): void {
    this.localStorageService.set(this.componentStorageKey, {
      visible: this.visible,
    });
  }

  private getBannerVisibility(): boolean | undefined {
    if (this.subscriptionService.isTrial()) return;

    const { visible } = this.localStorageService.get(this.componentStorageKey, {
      visible: true,
    });
    return visible;
  }
}
